// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_FOOTER_DEFAULT = 'global.footerDefault';
export const GLOBAL_REFER_FRIEND = 'global.referAFriend';

export const GlobalFooterDefault = {
  global: {
    footerDefault: {
      lbl_footerDefault_connectwithus: 'CONNECT WITH US:',
      lbl_footerDefault_referenceId: 'Reference ID :',
      lbl_footerDefault_offerzone: 'Offer Zone',
    },
  },
};

export const GlobalReferAFriend = {
  global: {
    referAFriend: {
      text: 'REFER A FRIEND',
    },
  },
};
